import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_image = _resolveComponent("input-image")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.languages, (language) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", { key: language }, [
      _createVNode(_component_input_image, {
        modelValue: $data.internalData[language],
        "onUpdate:modelValue": ($event: any) => (($data.internalData[language]) = $event),
        label: _ctx.label,
        rules: _ctx.rules,
        module: _ctx.module,
        useSignedUrl: _ctx.useSignedUrl,
        "type-code": _ctx.typeCode,
        canBeDeleted: _ctx.canBeDeleted,
        maxHeight: _ctx.maxHeight,
        maxFileSize: _ctx.maxFileSize,
        showFullSizePreviewOnHover: _ctx.showFullSizePreviewOnHover,
        language: language,
        isMultilingual: _ctx.$can('use-feature', 'MULTILINGUAL'),
        onImageCleared: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('imageCleared'))),
        onPreviewUrlChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('previewUrlChanged', $event)))
      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "rules", "module", "useSignedUrl", "type-code", "canBeDeleted", "maxHeight", "maxFileSize", "showFullSizePreviewOnHover", "language", "isMultilingual"])
    ])), [
      [_vShow, $props.activeLanguage === language]
    ])
  }), 128))
}